import {useSetRecoilState} from 'recoil';
import {useQuery} from 'react-query';
import {currentUserData} from '../state/currentUser/currentUser';
import actions from '../api/currentUser';

const useFetchCurrentUser = () => {
  const setCurrentUser = useSetRecoilState(currentUserData);
  return useQuery('fetchCurrentUser', async () => {
    const currentUser = await actions.fetchCurrentUser();
    setCurrentUser(currentUser.data);
    return currentUser;
  });
};

export default useFetchCurrentUser;
